import { SnmpDestination, SnmpV3User } from 'data/snmp/snmp.types';
import {
  FormTemplate,
  FormTemplateOption,
  FormTemplateSection
} from 'data/template/template.types';
import cloneDeep from 'lodash.clonedeep';

/* eslint-disable import/prefer-default-export */
export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view' | 'copy'
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

function setAllFieldsAsReadOnlyExcludingFields(
  template: FormTemplate,
  excludingFields: string[]
) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}

export function adaptTemplateOnLoad(
  snmpDest: SnmpDestination,
  template: FormTemplate
) {
  const templateClone = cloneDeep(template);

  if (snmpDest.VERSION === 'SNMPV3') {
    (templateClone.main as FormTemplateSection).fields.SECURITYNAMEV3.initial =
      snmpDest.SECURITYNAME;
  }

  templateClone.key = Date.now().toString();
  templateClone.formId = Date.now().toString();
  return templateClone;
}

export function adaptTemplateOptions(
  template: FormTemplate,
  snmpUsers: SnmpV3User[]
) {
  const templateClone = cloneDeep(template);
  // TODO: SET SNMP User OPTIONS
  const snmpUsersOptions: FormTemplateOption[] = [];
  snmpUsers.forEach((entry) => {
    snmpUsersOptions.push({
      label: entry.USERNAME,
      value: entry.USERNAME
    });
  });
  const oldLength =
    (templateClone.main as FormTemplateSection).fields.SECURITYNAMEV3.options
      ?.length ?? 0;
  const spliceLength = oldLength > 1 ? oldLength - 1 : 0;
  (templateClone.main as FormTemplateSection).fields.SECURITYNAMEV3.options?.splice(
    1,
    spliceLength,
    ...snmpUsersOptions
  );
  templateClone.key = Date.now().toString();
  templateClone.formId = Date.now().toString();
  return templateClone;
}

export function adaptSnmpDestTemplate(
  template: FormTemplate,
  fieldName: string,
  value: string
): FormTemplate {
  const clonedTemplate = cloneDeep(template);

  if (!clonedTemplate.main?.fields) {
    return clonedTemplate;
  }

  if (fieldName === 'VERSION') {
    if (value === 'SNMPV3') {
      setHiddenField(clonedTemplate, 'SECURITYNAME', true);
      setHiddenField(clonedTemplate, 'SECURITYNAMEV3', false);
    } else {
      setHiddenField(clonedTemplate, 'SECURITYNAME', false);
      setHiddenField(clonedTemplate, 'SECURITYNAMEV3', true);
    }
  }

  clonedTemplate.key = Date.now().toString();
  clonedTemplate.formId = Date.now().toString();
  return clonedTemplate;
}

function setRequiredValidationToField(
  template: FormTemplate,
  fieldName: string,
  required: boolean
) {
  const formSection = template.main;
  if (formSection == null) {
    return;
  }

  const field = formSection.fields[fieldName];
  if (field == null) {
    return;
  }

  if (field.validation) {
    field.validation.required = required;
  }
}

function setHiddenField(
  template: FormTemplate,
  fieldName: string,
  hide: boolean
) {
  const formSection = template.main;
  if (formSection == null) {
    return;
  }

  const field = formSection.fields[fieldName];
  if (field == null) {
    return;
  }
  field.hide = hide ? 'true' : 'false';
}
